module.exports = __webpack_public_path__ + "img/Openanaccount.9f633ca6.png";